import React from "react";
import {
	SalesActivityModuleState,
	useSalesActivityModuleDispatch,
	useSalesActivityModuleSelector
} from "../../../store";
import TaskDrawer from "./Task";
import MeetingDrawer from "./Meeting";
import LogCallDrawer from "./LogCall";
import LogEmailDrawer from "./LogEmail";
import CommentDrawer from "./Comment";
import { ZomentumRoutes } from "@/Contracts";
import SalesActivityActionCreators from "../../../store/actions/SalesActivity";
import useHandleAddSalesActivity from "../../../hooks/SalesActivity/useHandleAddSalesActivity";
import useHandleEditSalesActivity from "../../../hooks/SalesActivity/useHandleEditSalesActivity";
import { useRouteMatch } from "react-router-dom";

const AddAllSalesActivities: React.FC = () => {
	const {
		globalAddTaskDrawerOpen,
		globalEditTaskDrawerOpen,
		globalAddMeetingDrawerOpen,
		globalEditMeetingDrawerOpen,
		globalAddLogCallDrawerOpen,
		globalEditLogCallDrawerOpen,
		globalAddLogEmailDrawerOpen,
		globalEditLogEmailDrawerOpen,
		globalAddCommentDrawerOpen,
		globalEditCommentDrawerOpen
	} = useSalesActivityModuleSelector((state: SalesActivityModuleState) => {
		return {
			globalAddTaskDrawerOpen:
				state.salesActivity.globalAddTaskDrawerOpen,
			globalEditTaskDrawerOpen:
				state.salesActivity.globalEditTaskDrawerOpen,
			globalAddMeetingDrawerOpen:
				state.salesActivity.globalAddMeetingDrawerOpen,
			globalEditMeetingDrawerOpen:
				state.salesActivity.globalEditMeetingDrawerOpen,
			globalAddLogCallDrawerOpen:
				state.salesActivity.globalAddLogCallDrawerOpen,
			globalEditLogCallDrawerOpen:
				state.salesActivity.globalEditLogCallDrawerOpen,
			globalAddLogEmailDrawerOpen:
				state.salesActivity.globalAddLogEmailDrawerOpen,
			globalEditLogEmailDrawerOpen:
				state.salesActivity.globalEditLogEmailDrawerOpen,
			globalAddCommentDrawerOpen:
				state.salesActivity.globalAddCommentDrawerOpen,
			globalEditCommentDrawerOpen:
				state.salesActivity.globalEditCommentDrawerOpen
		};
	});

	const dispatch = useSalesActivityModuleDispatch();

	const { handleAddSalesActivity, handleCloseAddSalesActivity } =
		useHandleAddSalesActivity();
	const handleEditSalesActivity = useHandleEditSalesActivity();

	const closeTaskDrawer = () => {
		if (globalEditTaskDrawerOpen) {
			dispatch(SalesActivityActionCreators.editGlobalTaskDrawerClosed());
			dispatch(
				SalesActivityActionCreators.updateCurrentActiveSalesActivity(
					null
				)
			);
		}
		if (globalAddTaskDrawerOpen) {
			dispatch(SalesActivityActionCreators.addGlobalTaskDrawerClosed());
			handleCloseAddSalesActivity();
		}
	};

	const closeMeetingDrawer = () => {
		if (globalEditMeetingDrawerOpen) {
			dispatch(
				SalesActivityActionCreators.editGlobalMeetingDrawerClosed()
			);
			dispatch(
				SalesActivityActionCreators.updateCurrentActiveSalesActivity(
					null
				)
			);
		}
		if (globalAddMeetingDrawerOpen) {
			dispatch(
				SalesActivityActionCreators.addGlobalMeetingDrawerClosed()
			);
			handleCloseAddSalesActivity();
		}
	};

	const closeLogEmailDrawer = () => {
		if (globalEditLogEmailDrawerOpen) {
			dispatch(
				SalesActivityActionCreators.editGlobalLogEmailDrawerClosed()
			);
			dispatch(
				SalesActivityActionCreators.updateCurrentActiveSalesActivity(
					null
				)
			);
		}
		if (globalAddLogEmailDrawerOpen) {
			dispatch(
				SalesActivityActionCreators.addGlobalLogEmailDrawerClosed()
			);
			handleCloseAddSalesActivity();
		}
	};

	const closeLogCallDrawer = () => {
		if (globalEditLogCallDrawerOpen) {
			dispatch(
				SalesActivityActionCreators.editGlobalLogCallDrawerClosed()
			);
			dispatch(
				SalesActivityActionCreators.updateCurrentActiveSalesActivity(
					null
				)
			);
		}
		if (globalAddLogCallDrawerOpen) {
			dispatch(
				SalesActivityActionCreators.addGlobalLogCallDrawerClosed()
			);
			handleCloseAddSalesActivity();
		}
	};

	const closeCommentDrawer = () => {
		if (globalEditCommentDrawerOpen) {
			dispatch(
				SalesActivityActionCreators.editGlobalCommentDrawerClosed()
			);
			dispatch(
				SalesActivityActionCreators.updateCurrentActiveSalesActivity(
					null
				)
			);
		}
		if (globalAddCommentDrawerOpen) {
			dispatch(
				SalesActivityActionCreators.addGlobalCommentDrawerClosed()
			);
			handleCloseAddSalesActivity();
		}
	};

	const isDocumentPreviewPage = useRouteMatch(
		ZomentumRoutes.DocumentsPdfView
	)?.isExact;
	const shouldNotMountDrawers = isDocumentPreviewPage;
	if (shouldNotMountDrawers) return <React.Fragment />;
	else
		return (
			<>
				<TaskDrawer
					onClose={closeTaskDrawer}
					onSubmit={
						globalEditTaskDrawerOpen
							? handleEditSalesActivity
							: handleAddSalesActivity
					}
					visible={
						globalAddTaskDrawerOpen || globalEditTaskDrawerOpen
					}
					isEditMode={globalEditTaskDrawerOpen}
				/>
				<MeetingDrawer
					onClose={closeMeetingDrawer}
					onSubmit={
						globalEditMeetingDrawerOpen
							? handleEditSalesActivity
							: handleAddSalesActivity
					}
					visible={
						globalAddMeetingDrawerOpen ||
						globalEditMeetingDrawerOpen
					}
					isEditMode={globalEditMeetingDrawerOpen}
				/>
				<LogCallDrawer
					onClose={closeLogCallDrawer}
					onSubmit={
						globalEditLogCallDrawerOpen
							? handleEditSalesActivity
							: handleAddSalesActivity
					}
					visible={
						globalAddLogCallDrawerOpen ||
						globalEditLogCallDrawerOpen
					}
					isEditMode={globalEditLogCallDrawerOpen}
				/>
				<LogEmailDrawer
					onClose={closeLogEmailDrawer}
					onSubmit={
						globalEditLogEmailDrawerOpen
							? handleEditSalesActivity
							: handleAddSalesActivity
					}
					visible={
						globalAddLogEmailDrawerOpen ||
						globalEditLogEmailDrawerOpen
					}
					isEditMode={globalEditLogEmailDrawerOpen}
				/>
				<CommentDrawer
					onClose={closeCommentDrawer}
					onSubmit={
						globalEditCommentDrawerOpen
							? handleEditSalesActivity
							: handleAddSalesActivity
					}
					visible={
						globalAddCommentDrawerOpen ||
						globalEditCommentDrawerOpen
					}
					isEditMode={globalEditCommentDrawerOpen}
				/>
			</>
		);
};

export default AddAllSalesActivities;
